//     This code was generated by a Reinforced.Typings tool. 
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.

import { IApiRequest } from '../../IApiRequest';

export class RemoveConnectionsRequest extends IApiRequest<void>
{
	public $type = 'RemoveConnectionsRequest';
	constructor(public data: { managerId: string, userIds: string[], companyId: string }) { super(); }
}
